import Vue from 'vue'
import Component from 'vue-class-component'
@Component({
    components: {
    },
})
export class languageMixin extends Vue {
    private languageData: any = {
        系统名称: 'TCM Diagnosis Training System',
        新建档案: 'New Record',// New Archive
        体质诊测: 'Constitution Diagnosis',// Constitution Diagnosis
        诊测统计: 'Diagnosis Statistics',//Diagnosis Statistics
        数据统计: 'Data Statistics',// Data Statistics
        知识库: 'Knowledge Base',// Knowledge Base
        系统设置: 'System Settings',//System Settings
        // 新建档案: 'Add',// New Archive
        // 体质诊测: 'Home',// Constitution Diagnosis
        // 诊测统计: 'Diagnosis',//Diagnosis Statistics
        // 数据统计: 'Statistics',// Data Statistics
        // 知识库: 'Knowledge',// Knowledge Base
        // 系统设置: 'Setting',//System Settings'
        健康概览: 'Health Overview',
        档案记录: 'Archive Records',
        健康评估: 'Health Assessment',
        批量打印报告: 'Batch Print Reports',
        四诊客观化数据: 'Objective Data from the Four Diagnostic Methods',
        四诊采集:'Four Diagnostic Data Collection',
        四诊分析结果:'Results of Four Diagnostic Analyses',
        健康测评数据: 'Health Assessment Data',
        健康设备数据: 'Health Equipment Data',
        健康测评: 'Health Assessment',

        测评量统计: 'Statistics of Assessment Volume',
        总体情况: 'Overall Situation',
        总测评量: 'Total Assessment Volume',
        本月测评量: "This Month's Assessment Volume",
        今日测评量: "Today's Assessment Volume",
        月测评趋势图: 'Monthly Assessment Trend Chart',
        统计年限: 'Statistical Year',
        各团体测评量分布状况: 'Distribution of Assessment Volumes among Different Groups',
        会员统计: 'Member',// Member Statistics
        总会员数: 'Total Number of Members',
        今日新增数: 'New Members Today',
        年龄分布: 'Age Distribution',
        性别分布: 'Gender Distribution',
        会员分布: 'Member Distribution',
        症状体征: 'Symptoms and Signs',
        中医疾病: 'TCM Diseases',
        中医证型: 'TCM Syndromes',
        中药方剂: 'Chinese Herbal Formulas',
        中药饮片: 'Chinese Herbal Slices',
        中医病因: 'TCM etiology',
        中医病机: 'TCM pathogenesis',
        中医治则: 'TCM therapeutic principles',
        中医治法: 'TCM therapeutic methods',
        临床路径: 'Clinical pathway',
        自动读取:'Auto Entry',
        输入:'Manual Entry',
        
        搜索: 'Search',
        来源管理: 'Source',
        新建来源: 'Add'
    }
    get language() {
        return this.$store.state.language;
    }
    getLanguage(val: any) {
        if (this.language && this.language == 'English' && this.languageData[val]) {
            return this.languageData[val]
        } else {
            return val
        }
    }
}